module.exports = __webpack_public_path__ + "img/box7-7-7.e7a83e46.png";